
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB1UExURQAAAP////////////////////////////////// //////j4+9Pa58XO39vg6/Dy97bB14udwLbB2JmpyPj5+77I3Ki10LfC1+Lm75qpyPHz9+ns8+nt 89Ta59vh683U48zU47fC2OLn76+71KGvzNPb5wAAAIdJrQgAAAAKdFJOUwBAj9/PnyAQkD+yeUh8 AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IlSlicsAAADh SURBVCjPhZLpFoIgEIVHXCORKCqgsmx5/1eMkRIhOd0fgvc7d9gGwCojOQ1UlBU41Q1dEKlHVtBF FUgbmhABqGhSGZRpSGC24rplrOP+PwePNmLU1uMJ8p34aMdj6JmlMoJYc38Q4nDEyiHkmFBSa3PC mQxg58qpsyt/CSBDq7cBc8UZ+4U3Jdeq+4UtWgMznOGGRBdAiRaftmbCo4wBcVfjMETnlBrdxxO/ 2sTXZ/T3gibmITWushjkZMGstUzP2MsjWgBJP3YJWRra9kxGyb/WhHox65raqiqjdE5W6L8BjsUj UdXvqbEAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMDRUMDI6MzI6MTQrMDA6MDA1qJ14AAAA JXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEyLTA0VDAyOjMyOjE0KzAwOjAwRPUlxAAAACh0RVh0ZGF0 ZTp0aW1lc3RhbXAAMjAyMy0xMi0wNFQwMzo1NzozNCswMDowMILP2+QAAAAASUVORK5CYII="}})])
          )
        }
      }
    